import PropTypes from "prop-types"
import parse from "html-react-parser"
import loaderDots from "images/web/loader-dots.svg?raw"

// Inlined rather than served through an <img> so the SVG's own animation
// restarts from 0% each time the dots mount. Sizing belongs to the caller.
export default function LoaderDots({ className }) {
  return (
    <span className={className} aria-hidden="true">
      {parse(loaderDots)}
    </span>
  )
}

LoaderDots.propTypes = {
  className: PropTypes.string,
}
